(function(){
  var h=document.documentElement;
  if(h.classList.contains('jaloe-overlay')){
    var t=function(){h.classList.toggle('jaloe-scrolled',window.scrollY>60)};
    t();
    window.addEventListener('scroll',t,{passive:true});
  }

  function isDesktop(){return window.matchMedia('(min-width: 990px)').matches;}

  document.querySelectorAll('header-menu').forEach(function(el){
    var details=el.querySelector('details');
    if(!details) return;
    var closeTimer;
    el.addEventListener('mouseenter',function(){
      if(!isDesktop()) return;
      clearTimeout(closeTimer);
      details.setAttribute('open','');
    });
    el.addEventListener('mouseleave',function(){
      if(!isDesktop()) return;
      closeTimer=setTimeout(function(){
        details.removeAttribute('open');
      },150);
    });
  });
})();
